import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapSidebarFilterComponent } from './map-sidebar-filter.component';
import {DxFormModule, DxPopupModule} from 'devextreme-angular';
import {DomainsSelectorDropdownModule} from 'shared';



@NgModule({
  declarations: [MapSidebarFilterComponent],
  imports: [
    CommonModule,
    DxPopupModule,
    DxFormModule,
    DomainsSelectorDropdownModule
  ],
  exports: [MapSidebarFilterComponent]
})
export class MapSidebarFilterModule { }
